enum bimTypeCodeClassificationTypeId {
  BimTypeCode = "085cc4d1-beb8-41f8-9738-fc6faf1430de",
}

export default bimTypeCodeClassificationTypeId;
